import { h } from 'preact';
import RowNoMargin from '../row/no-margin';
import Column from '../column';
import Container from '../container';

export const Section = ({ children, rowClass, columnClass, containerClass }) => (
	<RowNoMargin class={rowClass}>
		<Column class={columnClass}>
			<Container class={containerClass}>
				{ children }
			</Container>
		</Column>
	</RowNoMargin>
);

export default Section;
